"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileTypeIcon;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _file = require("../utils/file");

var _Constants = require("../Constants");

var _Audio = _interopRequireDefault(require("./icons/Audio"));

var _Document = _interopRequireDefault(require("./icons/Document"));

var _ExcelFile = _interopRequireDefault(require("./icons/ExcelFile"));

var _PDF = _interopRequireDefault(require("./icons/PDF"));

var _Video = _interopRequireDefault(require("./icons/Video"));

var _Image = _interopRequireDefault(require("./icons/Image"));

var _WordFile = _interopRequireDefault(require("./icons/WordFile"));

var _FileTypeIcon = require("../constants/FileTypeIcon");

var _overrideIconDimensionsForCustomIcon = _interopRequireDefault(require("../utils/overrideIconDimensionsForCustomIcon"));

function FileTypeIcon(props) {
  var file = props.file,
      other = (0, _objectWithoutProperties2.default)(props, ["file"]);
  var extension = file.get('extension');
  var type = file.get('type') ? file.get('type') : (0, _file.getType)(extension);
  var Icon;

  switch (type) {
    case _Constants.FileTypes.AUDIO:
      Icon = _Audio.default;
      break;

    case _Constants.FileTypes.MOVIE:
      Icon = _Video.default;
      break;

    case _Constants.FileTypes.DOCUMENT:
      if (extension === 'pdf') {
        Icon = _PDF.default;
      } else if (_FileTypeIcon.WordExtensions.includes(extension)) {
        Icon = _WordFile.default;
      } else if (_FileTypeIcon.ExcelExtensions.includes(extension)) {
        Icon = _ExcelFile.default;
      } else {
        Icon = _Document.default;
      }

      break;

    case _Constants.FileTypes.IMG:
      Icon = _Image.default;
      break;

    default:
      Icon = _Document.default;
  }

  var iconProps = _FileTypeIcon.UIComponentIcons.includes(Icon) ? other : (0, _overrideIconDimensionsForCustomIcon.default)(other, props.size);
  return _react.default.createElement(Icon, Object.assign({
    className: "file-type-icon m-right-0"
  }, iconProps));
}

FileTypeIcon.propTypes = {
  file: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(Object.keys(_FileTypeIcon.ICON_SHIRT_SIZES)), _propTypes.default.number])
};
module.exports = exports.default;